import React from "react";
import Select from "react-select";
import { InputGroupAddon, InputGroup, InputGroupText, Row, Col, Label } from "reactstrap";

import { connect } from "react-redux";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import { authHeader } from "../../../../helpers/authHeader";
import { cmsActions } from "../../../../store/actions/cms/cms.action";
import { arrayHelper } from "../../../../helpers/arrayHelper";
import FileStorageWrapper from "../../../../components/FileStorage/FileStorageWrapper";
import PermMediaIcon from "@material-ui/icons/PermMedia";
import { IconButton } from "@material-ui/core";
import { archiveConstants } from "../../../../components/FileStorage/contstants/archive.contstants";

const API_KEY = "AIzaSyB6aQW4uFg8OuFMHaxBmqDPCvzBGe5vuTg";
const customStyles = {
  control: (provided, state) => ({
    ...provided,

    backgroundColor: "#50525d",
    color: "#eee",
    border: "0px",
    maxWidth: "calc(100% - 48px)%",
    width: 233,
  }),
  noOptionsMessage: (provided, state) => ({
    ...provided,
    color: "green",
    maxWidth: "100%",
  }),
  input: (provided, state) => ({
    ...provided,
    color: "#eee",
    maxWidth: "100%",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#eee",
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    background: "transparent",
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#373842",
    maxWidth: "100%",
    zIndex: 100,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#20a8d8" : "#3d3d3d",
    color: "#eee",
    ["&:hover"]: {
      backgroundColor: "#5a5959ba",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#eee",
  }),
};
const rowStyle = {
  display: "inline-flex",
  width: "100%",
  maxWidth: "100%",
  margin: "0px",
};
const colourStyles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      fontFamily: data.value,
    };
  },
};

class FontPicker extends React.Component {
  constructor(props) {
    super(props);
    this.fontPickerRef = React.createRef();
    this.toggle = this.toggle.bind(this);
    this.state = {
      categoryOptions: ["All", "sans-serif", "serif", "display", "handwriting", "monospace"],
      selectedCategory: "All",
      clientFonts: [],
      fonts: [],
      sortOptions: ["alpha", "date", "popularity", "style", "trending"],
      sortBy: "alpha",
      fontPicker: null,
      dropdownOpen: false,
      previewFont: "",
      categoriesOpen: false,
      sortByOpen: false,
      archiveOpen: false,
    };
  }
  setStyle = (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      option: {
        fontFamily: data.value,
        fontWeight: "400",
        fontSize: "0.875rem",
        paddingLeft: "1.5px",
      },
    };
  };
  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }
  componentDidMount() {
    this.dowloadClientFonts();
    this.dowloadGoogleFonts();
  }
  componentDidUpdate(prevProps) {
    if (this.props.cms.fonts !== undefined && prevProps.cms.fonts !== this.props.cms.fonts) {
      this.props.cms.fonts.map((cf) => {
        if (
          !this.state.fonts.find((t) => {
            return t === cf.name;
          })
        ) {
          this.setState({ fonts: [cf.name, ...this.state.fonts] });
        }
      });
    }
  }
  dowloadClientFonts = (update = false) => {
    const fonts = [];
    const clientFonts = [];
    const requestOptions = {
      method: "GET",
      headers: authHeader({ "Content-Type": "application/json" }),
    };
    fetch(`./api/files/?format=font&eventId=${this.props.eventId}`, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.files) {
          data.files.map((f) => {
            fonts.push(this.convertFont(f.name));
            clientFonts.push({ name: this.convertFont(f.name), url: f.url });
          });
        }
        this.props.dispatch(cmsActions.loadClientFonts(clientFonts));
        this.setState({
          fonts: arrayHelper.concat(this.state.fonts, fonts),
          clientFonts: clientFonts,
        });
      })
      .catch((err) => console.error(err));
  };
  convertFont = (f) => {
    return f
      .substring(f.lastIndexOf("/") + 1, f.lastIndexOf(".") + 1)
      .toString()
      .replace(")", "")
      .replace("(", "")
      .replace(".", "")
      .replace("1", "")
      .replace("", "");
  };
  dowloadGoogleFonts = () => {
    const fonts = [...this.state.fonts];
    fetch(`https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=${API_KEY}`)
      .then((res) => res.json())
      .then((data) => {
        data.items.splice(0, 200).map((f) => {
          fonts.push(f.family);
        });
        let cFonts = ["Arial", "Helvetica", "Times New Roman", "Times", "Courier New", "Courier", "Verdana", "Georgia", "Comic Sans MS", "Trebuchet MS", "Arial Black", "Impact"];
        let f = [...cFonts, ...fonts];
        const n = arrayHelper.concat(this.state.fonts, fonts).sort(function (a, b) {
          if (a.family < b.family) {
            return -1;
          }
          if (a.family > b.family) {
            return 1;
          }
          return 0;
        });
        this.setState({ fonts: f });
      })
      .catch((err) => console.error(err));
  };
  toggleExtensions = (type) => {
    this.setState({ [type]: !this.state[type] });
  };
  sortBy = (sortBy) => {
    this.setState({ sortBy }, () => {
      this.dowloadGoogleFonts();
    });
  };
  selectFont = (font) => {
    this.props.onChange(null, font, this.props.path);
    this.setState({ archiveOpen: false });
  };

  categoryOnChange = (category) => {
    this.setState({ selectedCategories: category });
  };
  filter = () => {
    const { selectedCategory, fonts } = this.state;

    if (selectedCategory === "All") {
      return fonts;
    }
    return fonts
      .filter((f) => {
        return f.category === selectedCategory && f;
      })
      .sort();
  };
  getFont = () => {
    const { currentFontFamily } = this.props;
    const { fonts } = this.state;

    let font = fonts.find((f) => {
      return f === currentFontFamily;
    });

    if (font !== undefined && font) {
      return { value: font, label: font };
    }
    return { value: "", label: "Font missing" };
  };
  toggleArchive = () => {
    this.setState({ archiveOpen: !this.state.archiveOpen });
  };
  onClientFontUpload = (font, url) => {
    this.props.dispatch(cmsActions.loadClientFonts([...this.state.clientFonts, { name: font, url: url }]));
  };

  adjustFontList = () => {
    const adjustedList = [...new Set(Array.from(this.state.fonts))]; /* .sort(
      (a, b) => a > b
    ); */
    return adjustedList;
  };

  render() {
    const { fontWeight } = this.props;
    /*     const { fonts } = this.state; */
    const fonts = this.adjustFontList();
    const selectStyles = {
      option: (styles, { data }) => {
        return {
          ...styles,
          fontSize: "12px",
          fontFamily: data.value,
          padding: "0 10px",
          fontWeight,
        };
      },
      container: (styles) => ({
        ...styles,
        minWidth: "100%",
      }),
      singleValue: (styles, { data }) => {
        return {
          ...styles,
          fontSize: "12px",
          fontFamily: data.value,
          fontWeight,
        };
      },
    };
    return (
      <React.Fragment>
        <Row>
          <Col className="list-setting-item-title">
            <Label className={"primary-text"}>
              <SystemLabel name="FontFamily" />
            </Label>
          </Col>
        </Row>
        <Row>
          <Col className="list-setting-item-title" style={{ lineHeight: "unset" }}>
            <InputGroup
              style={{
                display: "inline-flex",
                flexWrap: "nowrap",
                alignItems: "unset",
                maxWidth: "87%",
              }}
            >
              <div style={{ width: 261 }}>
                <Select
                  className="jirango-select"
                  options={
                    fonts &&
                    fonts.sort().map((t) => {
                      return { value: t, label: t };
                    })
                  }
                  value={this.getFont()}
                  onChange={(selectedOption) => this.selectFont(selectedOption.value)}
                  styles={customStyles}
                />
              </div>
              <InputGroupAddon onClick={this.toggleArchive} addonType="append">
                <InputGroupText
                  className={this.props.nonWrapped ? "" : "dark-l1"}
                  style={{
                    border: 0,
                    background: "transparent",
                    cursor: "pointer",
                    marginLeft: "-2px",
                    color: "white",
                  }}
                >
                  <PermMediaIcon style={{ color: "rgba(238, 238, 238, 0.933)" }} />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Col>
        </Row>
        <br />
        {this.state.archiveOpen ? (
          <FileStorageWrapper
            fontEnabled={true}
            onUseSelected={this.selectFont}
            onFontUpload={this.onClientFontUpload}
            toggle={this.toggleArchive}
            isOpen={this.state.archiveOpen}
            initialDisplay={archiveConstants.FONT}
            showLaunchBtn={false}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    cms: state.cms,
    eventId: state.cms.eventId,
  };
}
export default connect(mapStateToProps)(FontPicker);
